import axios1 from "axios";
import logger from "./logService";
import { toast } from "react-toastify";

const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI1ZjdkNzE3YWQ5N2MyYzAwMTc5NjBhMTAiLCJuYW1lIjoiQ2FybG9zIFJpYmVpcm8iLCJlbWFpbCI6IjEiLCJjb2RfYXRsZXRhIjoyLCJjdXN0b21lckFicmV2aWF0dXJhIjoiTElGRUNMVUIiLCJpYXQiOjE3NDc4NDA3MTN9.RneOD2GQWN2O64jYX_MNX0fheiXcSWLWmT9vDa_R8Ew";

axios1.defaults.headers.common['x-auth-token'] = token;


//axios1.defaults.baseURL = process.env.REACT_APP_API_CUSTOMER_URL;
axios1.defaults.baseURL = process.env.REACT_APP_SERVER_URL;

// 2020-10-28 console.log("httpServiceCustomer", axios1.defaults.baseURL);

axios1.interceptors.response.use(null, (error) => {
  const expectedError =
    error.response &&
    error.response.status >= 400 &&
    error.response.status < 500;

  if (!expectedError) {
    logger.log(error);
    toast.error("An unexpected error occurrred.");
  }

  return Promise.reject(error);
});

export default {
  get: axios1.get,
};
